import { Building2, Mail, Phone, UserSearch } from 'lucide-react';

export const HOME_MODULES = [
  {
    id: 'company',
    title: 'Corporate Search',
    short: 'Infrastructure & companies',
    mobileLabel: 'Corp',
    mobileEmoji: '🏢',
    pattern: 'e.g. acme.com, brand name, Paris',
    placeholder: 'acme.com, brand name, Paris…',
    cta: 'Investigate Company',
    accent: 'blue',
    Icon: Building2,
    help: 'Domain + location + context in one line (e.g. company.ro Brand City). Sanctions/compliance, domain security, registry signals, LinkedIn key persons (hybrid), and industry-aware adverse media.',
  },
  {
    id: 'person',
    title: 'Person Search',
    short: 'Name, alias, digital footprint',
    mobileLabel: 'Person',
    mobileEmoji: '👤',
    pattern: 'e.g. Jane Doe, Bucharest, @janedoe',
    placeholder: 'Jane Doe, Bucharest, @janedoe…',
    cta: 'Find Person',
    accent: 'cyan',
    Icon: UserSearch,
    help: 'Name + city/employer in one line, or :: before context. Prefix handles with @ for username-only pivots.',
  },
  {
    id: 'email',
    title: 'Email Intelligence',
    short: 'Breaches & data exposure',
    mobileLabel: 'Email',
    mobileEmoji: '✉️',
    pattern: 'e.g. name@company.com',
    placeholder: 'name@company.com…',
    cta: 'Analyze Email',
    accent: 'violet',
    Icon: Mail,
    help: 'Breach-style exposure timelines (HIBP-class signals), dormant account discovery, domain reputation, and infrastructure rows when certificate or host metadata is available. GHunt paths require configured credentials.',
  },
  {
    id: 'phone',
    title: 'Phone Lookup',
    short: 'Metadata & number identity',
    mobileLabel: 'Phone',
    mobileEmoji: '📱',
    pattern: 'e.g. +40 721 123 456',
    placeholder: '+40 721 123 456…',
    cta: 'Trace Number',
    accent: 'emerald',
    Icon: Phone,
    help: 'Carrier and region metadata, numeric breach checks, open-web mentions, and structured telephony pivots. Regional dial-plan scope respects deployment configuration.',
  },
];

/** Short placeholder for narrow search fields when no module is forced yet. */
export const PLACEHOLDER_MOBILE_COMPACT = 'Person, company, phone, domain…';

export const PLACEHOLDER_UNIVERSAL =
  'Name, username, email, phone, domain, or company…';

/**
 * Placeholder syntax for the active investigation module.
 * When ``moduleId`` is null/empty (idle auto), returns the universal hint.
 *
 * @param {string|null|undefined} moduleId
 * @param {{ compact?: boolean }} [opts]
 * @returns {string}
 */
export function placeholderForModule(moduleId, opts = {}) {
  if (!moduleId) {
    return opts.compact ? PLACEHOLDER_MOBILE_COMPACT : PLACEHOLDER_UNIVERSAL;
  }
  const mod = HOME_MODULES.find((m) => m.id === moduleId);
  return mod?.placeholder || PLACEHOLDER_UNIVERSAL;
}
